<form nz-form nzLayout="vertical" (ngSubmit)="handleOk()">
  <nz-descriptions class="user-header" nzSize="small" [nzBordered]="true" [nzColumn]="1">
    <nz-descriptions-item [nzTitle]="'adminUsers.user' | translate">{{ username }}</nz-descriptions-item>
  </nz-descriptions>

  <nz-form-item>
    <nz-form-label nzRequired>Email</nz-form-label>
    <nz-form-control [nzErrorTip]="'adminUsers.emailInvalid' | translate">
      <input nz-input type="email" [formControl]="emailControl" placeholder="user@example.kz">
    </nz-form-control>
  </nz-form-item>
</form>
